import { BaseApiService } from '@/Services/base-api-service'
import { isAxiosError } from '@/Services/HttpClient/axios-plugin'
import { IPersonEmail } from '../Models/IPersonEmail';
import { ITypedValidationResult } from '../Models/IValidationResult';

class personEmailService extends BaseApiService {
    public constructor() {
        super('PersonEmail/');
    }

    private static config = {
        headers: {
            'AuthorizationNeeded': true,
            // Other headers can be added here if needed
        }
    };

    public async getByPersonEmailId(personEmailId: number, auth0Id: string): Promise<IPersonEmail> {
        return this.httpClient.get<IPersonEmail>(`GetByPersonEmailId?personEmailId=${personEmailId}&auth0Id=${auth0Id}`, personEmailService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getByPersonId(personId: number, auth0Id: string): Promise<IPersonEmail> {
        return this.httpClient.get<IPersonEmail>(`GetByPersonId?personId=${personId}&auth0Id=${auth0Id}`, personEmailService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async savePersonEmail(email: IPersonEmail, auth0Id: string) {
        console.log('Updating Person Email');
        this.httpClient.post<ITypedValidationResult<IPersonEmail>>(`SavePersonEmail?auth0Id=${auth0Id}`, email, personEmailService.config).catch(this.handleError.bind(this));
    }

}

export const PersonEmailService: personEmailService = new personEmailService();